module.exports = __webpack_public_path__ + "img/HPFM_hammer_mobile.abe947b1.png";